/**
 * Utility function to check if login bypass is enabled in development mode.
 * This allows testing and development without authentication.
 *
 * @returns {boolean} True if bypass login is enabled, false otherwise
 */
export function isBypassLoginEnabled(): boolean {
  return import.meta.env.DEV && globalThis.__BYPASS_LOGIN__ === true;
}

export default isBypassLoginEnabled;
